"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearAllNotifications = clearAllNotifications;
exports.getNotificationsList = getNotificationsList;
exports.notificationProduceApi = notificationProduceApi;
exports.notificationProduceLabTestApi = notificationProduceLabTestApi;
exports.sendLabReportNotificationApi = sendLabReportNotificationApi;
exports.setAllNotificationsAsRead = setAllNotificationsAsRead;
exports.uploadPushNotificationToken = uploadPushNotificationToken;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function uploadPushNotificationToken(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.UPLOAD_PUSH_NOTIFICATION_TOKEN}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({
  //   apiEndPoint,
  //   requestType: API_PARAMS.POST,
  //   apiPostData: requestParams
  // });
}
function getNotificationsList(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_NOTIFICATIONS}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function setAllNotificationsAsRead(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_NOTIFICATIONS}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST });
}
function notificationProduceApi(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.NOTIFICATION_PRODUCE}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: params, requestType: API_PARAMS.POST });
}
function notificationProduceLabTestApi(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.NOTIFICATION_PRODUCE_LABTEST}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function clearAllNotifications(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_NOTIFICATIONS}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.DELETE });
}
function sendLabReportNotificationApi(params, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_LAB_NOTIFICATIONS}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}